import { Card, Stack, Typography } from '@mui/material';
import { useBreakpoint } from '@juno/utils';

export const FilterSidePanel = ({ children }: { children: React.ReactNode }) => {
  const { sm } = useBreakpoint();
  return (
    <Card sx={{ p: 1, mb: 1.5 }}>
      <Stack direction={sm ? 'column' : 'row'} alignItems={'center'} sx={{ mb: 2, pl: 1 }}>
        <Typography variant='h6'>Filter Options</Typography>
      </Stack>
      {children}
    </Card>
  );
};
